import { useContext } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import { useLocation } from 'react-router-dom';
import { useGenericEntities } from 'app/agriculture/queries/entities/useGenericEntities';
import { Entity } from 'app/agriculture/queries/entities/types/Entity';
import { isEntityType } from 'app/agriculture/models/Entities';

export function useInitialParent(): Entity | undefined {
    const { assetCollection } = useContext(ServicesContext);
    const entities = useGenericEntities();
    const location = useLocation();

    if (!isObjectContainingParentId(location.state)) return undefined;
    const { parentId } = location.state;

    const asset = assetCollection.get(parentId);

    // If no asset found, check entities

    if (asset == null) return entities.get(parentId);

    const { id, name, type, creator_id } = asset;
    if (!isEntityType(type.name)) throw new Error(`Asset type unsupported: ${type.name}`);
    return { id, name, type: type.name, creatorId: creator_id };
}

function isObjectContainingParentId(x: unknown): x is { parentId: string | number } {
    if (x == null || typeof x !== 'object' || !('parentId' in x)) return false;
    return typeof x.parentId === 'string' || typeof x.parentId === 'number';
}
